import { render, staticRenderFns } from "./ghg-form.vue?vue&type=template&id=2fafd2d2&"
import script from "./ghg-form.vue?vue&type=script&lang=js&"
export * from "./ghg-form.vue?vue&type=script&lang=js&"
import style0 from "./ghg-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports